import application from 'application/application';
import controller from './excel-svg.controller';

import template from './excel-svg.template.html';

application.directive('appExcelSvg', [
	function() {
		return {
			restrict: 'E',
			replace: true,
			scope: {
				size: '@?'
			},
			controller: controller,
			templateUrl: template
		};
	}
]);
